import { EncoderDecoderInterface } from "silver";

// This does not work with the Int32Array object, but does encode an array of numbers, max 32bit int
export class Int32ArrayEncoder implements EncoderDecoderInterface<number[], string> {

	encode(numbers: number[]): string {
		let out: string = "";
		for (let i = 0; i < numbers.length; i++) {
			const uint32 = (numbers[i] >>> 0);
			out += String.fromCodePoint(Math.floor(uint32 / 0xffff), uint32 % 0xffff);
		}
		return out;
	}

	decode(value: string): number[] {
		const out: number[] = [];
		const chars = value.split("");
		for (let i = 0; i < chars.length; i += 2) {
			const upper = chars[i];
			const lower = chars[i + 1];
			const uint32 = Number(upper.codePointAt(0)) * 0xffff + Number(lower.codePointAt(0));
			out.push(uint32 << 0);
		}
		return out;
	}
}
